<template>
    <section
        id="section-values-id-link"
        class="bg-white full-width relative tablet:h-screen flex flex-col">
        <!--Image Background-->
        <background-image
            :src="sectionValues.imageSources.src"
            :srcset="sectionValues.imageSources.imgSrcSet" />

        <!--Content Layout in a Container-->
        <div class="container flex z-10 pt-8 tablet:pt-16 pb-16 phone:h-475px">
            <!--Aside Block -- Content Text Aside Component -- Matches Layout Spacer div below for sizing/spacing-->
            <div class="section-content flex flex-col z-10">
                <!--Aside Text Component-->
                <content-text-aside
                    class=" max-w-xxs mr-10 desktop:mr-32"
                    gold>
                    <template #title-text>
                        <span class="text-white">{{ sectionValues.contentTextAside.contentTextAsideTitle }}</span>
                    </template>
                </content-text-aside>
                <tis-button
                    class="btn-flat block text-sm -mt-4 group transition-transform"
                    :url="route('web.contact')">
                    {{ sectionValues.contentTextAside.buttonText }}
                    <svg-icon
                        icon="arrow-horizontal"
                        class="w-6 h-6 inline-block ml-2 transition-transform transform duration-200 group-hover:translate-x-1" />
                </tis-button>
            </div>
        </div>

        <!-- Values Content Div - White Background -->
        <div
            class="py-8 bg bg-white z-10 tablet:absolute tablet:bottom-0 tablet:w-full desktop:h-full desktop:w-auto desktop:right-0 desktop:pt-16 hd:pt-40">
            <!-- Content Layout in Container -->
            <div class="container tablet:flex desktop:flex-col desktop:px-12 hd:px-20">
                <!-- Values Content Div 1 - Text -->
                <div class="pb-8 desktop:pb-16 hd:pb-24">
                    <h2
                        class="text-gray-700 text-3xl font-regular uppercase pb-3 desktop:pb-6"
                        v-html="sectionValues.mainContent.title">
                    </h2>
                    <div
                        class="text-gray-700 max-w-sm desktop:max-w-md desktop:text-lg"
                        v-html="sectionValues.mainContent.content">
                    </div>
                </div>

                <!-- Values Content Div 2 - Icon Components Container -->
                <div class="flex tablet:ml-20 desktop:ml-0">
                    <!-- Icon Component Div 2.1 -->
                    <div class="flex mr-6 tablet:mr-10 tablet:flex-col desktop:mr-12 hd:mr-16">
                        <!-- Icon Component 1 -->
                        <div class="icon-component mr-6 tablet:mb-12 desktop:mb-16">
                            <svg-icon
                                icon="quality"
                                :class="classes.iconComponent.icon" />
                            <hr
                                :class="classes.iconComponent.hr">
                            <p :class="classes.iconComponent.iconText">
                                {{ sectionValues.mainContent.iconComponentTitleOne }}
                            </p>
                        </div>
                        <!-- Icon Component 2 -->
                        <div class="icon-component">
                            <svg-icon
                                icon="flexibility"
                                :class="classes.iconComponent.icon" />
                            <hr
                                :class="classes.iconComponent.hr">
                            <p :class="classes.iconComponent.iconText">
                                {{ sectionValues.mainContent.iconComponentTitleTwo }}
                            </p>
                        </div>
                    </div>
                    <!-- Icon Component Div 2.2 -->
                    <div class="flex tablet:flex-col">
                        <!-- Icon Component 3 -->
                        <div class="icon-component mr-6 tablet:mb-12 desktop:mb-16">
                            <svg-icon
                                icon="lightBulb"
                                :class="classes.iconComponent.icon" />
                            <hr
                                :class="classes.iconComponent.hr">
                            <p :class="classes.iconComponent.iconText">
                                {{ sectionValues.mainContent.iconComponentTitleThree }}
                            </p>
                        </div>
                        <!-- Icon Component 4 -->
                        <div class="icon-component">
                            <svg-icon
                                icon="respect"
                                :class="classes.iconComponent.icon" />
                            <hr
                                :class="classes.iconComponent.hr">
                            <p :class="classes.iconComponent.iconText">
                                {{ sectionValues.mainContent.iconComponentTitleFour }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ContentTextAside from '@web/components/ContentTextAside';
import ContentText from '@web/components/ContentText';
import BackgroundImage from '@web/components/BackgroundImage';
import TisButton from '@whisper/components/buttons/TisButton';
import SvgIcon from '@whisper/components/icons/SvgIcon';

export default {
  components: {
    TisButton,
    SvgIcon,
    ContentTextAside,
    BackgroundImage,
    ContentText,
  },
  props: {
    sectionValues: {
      type: Object,
      required: true,
      imageSources: {
        type: Object,
        required: true,
      },
      contentTextAside: {
        type: Object,
        required: true,
      },
      mainContent: {
        type: Object,
        required: true,
      },
    },
  },
  data: () => ({
    classes: {
      iconComponent: {
        hr: [
          'text-gold-500',
          'w-16',
          'tablet:w-24',
          'mt-3',
          'mb-2',
          'desktop:w-40',
          'desktop:mt-6',
          'desktop:mb-5',
          'hd:mt-8',
          'hd:mb-6',
        ],
        icon: [
          'h-10',
          'tablet:h-14',
          'desktop:h-16',
          'hd:h-20',
          'text-gray-800',
        ],
        iconText: [
          'uppercase',
          'text-gray-800',
          'font-regular',
          'mobile:text-sm',
          'desktop:text-xl',
        ],
      },
    },
  }),
};
</script>

<style scoped>

</style>
